/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, minutes: NonNullable<unknown> }} Shell_Idle_SessionInputs */

const en_us2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const pt_br2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const es_419_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const pt_pt2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const fr_fr2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const de_de2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

const it_it2_shell_idle_session = /** @type {(inputs: Shell_Idle_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} · ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{title} · {minutes} min" |
*
* @param {Shell_Idle_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_idle_session = /** @type {((inputs: Shell_Idle_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Idle_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_idle_session(inputs)
	if (locale === "es-419") return es_419_shell_idle_session(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_idle_session(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_idle_session(inputs)
	if (locale === "de-DE") return de_de2_shell_idle_session(inputs)
	if (locale === "it-IT") return it_it2_shell_idle_session(inputs)
	return en_us2_shell_idle_session(inputs)
});
export { shell_idle_session as "shell.idle_session" }